// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3efM0","alert":"SettungsInbox_alert__3uYSg"};